import { renderInDocument } from '@spotahome/soyuz/client';

import ContractTypesContainer from './main';

renderInDocument(ContractTypesContainer);
